import { useQuery } from "react-query";
import { fetchData } from "../api/client";

/**
 * Estado de onboarding no servidor (GET /setup/status).
 */
export function useSetupOnboardingStatus(companyKey, enabled = true) {
  return useQuery(
    ["setup-onboarding-status", companyKey],
    async () => {
      const res = await fetchData("/setup/status", "GET");
      const raw = res?.data ?? res;
      return raw && typeof raw === "object" ? raw : {};
    },
    {
      enabled: Boolean(enabled && companyKey),
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
}
